import React, { useMemo } from 'react';
import { Row } from 'components';
import { RejectModal } from './RejectModal';
import { ConvertModal } from './ConvertModal';
import { PERMISSIONS } from 'constants/permissions';
import { useChangeStatus } from './useChangeStatus';
import { FinalStatusBanner } from './FinalStatusBanner';
import { HasAccess } from 'components/common/accessControl';
import { StatusChangeDropdown } from './StatusChangeDropdown';
import { AllowedStatusTransitions, RejectionReasons } from 'models/Lead';
import { LeadStatusType } from 'components/common/StatusBadge/LeadStatusBadge';

export const LeadStatusChange = () => {
  const {
    form,
    leadDetails,
    isRejectionModalVisible,
    isFinalStatusBannerVisible,
    isFinalStatus,
    isLoading,
    handleStatusClick,
    handleRejectionConfirm,
    handleModalCancel,
    isConvertModalVisible,
    handleConvertConfirm,
  } = useChangeStatus();

  // Get menu items based on current status
  const changeStatusMenu = useMemo(() => {
    const currentStatus = leadDetails.status as LeadStatusType;
    if (!currentStatus) return [];
    const availableOptions = AllowedStatusTransitions[currentStatus] || [];
    return availableOptions.map((status) => ({
      label: status,
      key: status,
    }));
  }, [leadDetails.status]);

  return (
    <>
      {isFinalStatusBannerVisible && <FinalStatusBanner status={leadDetails.status} />}
      <HasAccess role={PERMISSIONS.leads.lead.write}>
        {!isFinalStatus && !isLoading && (
          <Row justify={'end'}>
            <StatusChangeDropdown
              disabled={isFinalStatus}
              menuItems={changeStatusMenu}
              onStatusClick={handleStatusClick}
            />
          </Row>
        )}
      </HasAccess>
      <RejectModal
        form={form}
        open={isRejectionModalVisible}
        onSubmit={handleRejectionConfirm}
        onCancel={handleModalCancel}
        rejectionReasons={Object.values(RejectionReasons)}
      />
      <ConvertModal open={isConvertModalVisible} onSubmit={handleConvertConfirm} onCancel={handleModalCancel} />
    </>
  );
};
